/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")


  
    
export interface API48714Item {
  
  /** id */
  krId?: string;
  
  /** 名称 */
  krName?: string;
  
  /** 完成度 */
  krCompleted?: string;
  
  /**  */
  krCompletedStr?: string;
  
};
    
  



export interface API48714Req {
  
  /** (String) */
  okrONo?: string;
    
};



export interface API48714Res {
  /** 名称  */
  objName?: string;
  /** 编号  */
  okrONo?: string;
  /** 负责人  */
  flowName?: string;
  /** 周期  */
  activePeriod?: string;
  /** 所属部门  */
  departName?: string;
  /** kr列表 ,KrDataResult  */
  krList?: API48714Item[];
  
};


// 48714 查询okr详情

export interface IUseGetAPI48714Return {
  /** 查询okr详情: 接口请求状态 */
  isAPI48714Loading: boolean;
  /** 查询okr详情: 接口请求返回数据 */
  dataAPI48714: API48714Res;
  /**  查询okr详情: 接口数据请求方法 */
  fetchAPI48714Data:  (inputs: API48714Req, config?: YWRequestConfig) => Promise<API48714Res>;
  /** 查询okr详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48714 = ():IUseGetAPI48714Return => {
  let isMount = true;
  const [isAPI48714Loading, setIsAPI48714Loading] = useState(false);
  const [dataAPI48714, setDataAPI48714] = useState<API48714Res>({} as API48714Res);
  const requestUrl = `${basePath}/internal-control-biz/project/okr/data/detail`;

  const fetchAPI48714Data = async (inputs: API48714Req, config?: YWRequestConfig): Promise<API48714Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48714Req>) || {}) as API48714Req;
    
  
    if ( isMount ) {
      setIsAPI48714Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48714Res>(`${basePath}/internal-control-biz/project/okr/data/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48714(res || {} as API48714Res);
        setIsAPI48714Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48714Loading(false);
      }
      return false as unknown as API48714Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48714Loading,
    dataAPI48714,
    fetchAPI48714Data,
    requestUrl,
  }
}

